import React from 'react';
import { useState, useEffect, useReducer, ReactNode } from 'react';
import Modal from 'react-modal';

const Close = () => {
    return <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z" />
        <path fillRule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z" />
    </svg>
}

const SlidingPane = (props) => {
    const directionClass = `slide-pane_from_${props.from}`;
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => setIsOpen(props.isOpen), [props.isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            className={`slide-pane ${directionClass} ${props.className ?? ''}`}
            closeTimeoutMS={1000}
            style={{
                content: { width: props.width ?? '90%' }
            }}
            overlayClassName={`slide-pane__overlay ${props.overlayClassName ?? ''}`}
        >
            <div className='slide-pane__header'>
                <div className='slide-pane__close' onClick={props.onRequestClose}>
                                    {props.closeIcon || <Close />}
                </div>
                <div className='slide-pane__title-wrapper'>
                    <h2 className='slide-pane__title'>{props.title} </h2>
                    <div className='slide-pane__subtitle'>{props.subtitle}</div>
                </div>
            </div>
            <div className='slide-pane__content'>
                {props.children}
            </div>
        </Modal>
    )
}
SlidingPane.displayName = "SlidingPane";

export { SlidingPane };